import { comicApps } from "@/mocks/apps";
import PageHeader from "@/components/feature/PageHeader";
import SectionHeading from "@/components/feature/SectionHeading";
import { Link } from "react-router-dom";

export default function AppPage() {
  return (
    <>
      <PageHeader
        title="韩漫APP合集"
        subtitle="한국 무료 만화 APP · 手机端合集"
        desc="手机看韩漫最省心的方式就是用APP。这里整理了目前口碑较好、更新稳定的韩漫阅读APP，支持无遮拦、缓存离线与多源切换，按需挑选。"
        crumbs={[{ label: "韩漫APP" }]}
      />

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-8 md:py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {comicApps.map((a) => (
            <article
              key={a.id}
              className="rounded-xl bg-background-100 border border-background-200/70 p-5 hover:border-primary-400/60 transition-all hover:-translate-y-1"
            >
              <div className="flex items-center justify-between">
                <span className="w-12 h-12 rounded-xl flex items-center justify-center text-xl font-heading text-background-50"
                  style={{ backgroundColor: a.color }}>
                  {a.name.slice(0, 1)}
                </span>
                <span className="text-xs text-foreground-600">{a.platform}</span>
              </div>
              <h2 className="mt-4 font-heading text-lg text-foreground-950">{a.name}</h2>
              <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{a.desc}</p>
              <div className="mt-3 flex flex-wrap gap-1.5">
                {a.features.map((f) => (
                  <span key={f} className="text-[11px] px-2 py-0.5 rounded-full bg-secondary-100/70 text-secondary-500 font-bold">
                    {f}
                  </span>
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-background-200/70 grid grid-cols-4 gap-2 text-center">
                <div>
                  <p className="text-accent-500 font-heading text-sm">{a.rating}</p>
                  <p className="text-[10px] text-foreground-600">评分</p>
                </div>
                <div>
                  <p className="text-foreground-800 text-sm">{a.size}</p>
                  <p className="text-[10px] text-foreground-600">大小</p>
                </div>
                <div>
                  <p className="text-foreground-800 text-sm">{a.downloads}</p>
                  <p className="text-[10px] text-foreground-600">下载</p>
                </div>
                <div>
                  <p className="text-secondary-500 text-sm">{a.update}</p>
                  <p className="text-[10px] text-foreground-600">更新</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section className="bg-background-100 border-y border-background-200/70">
        <div className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14">
          <SectionHeading
            eyebrow="APP PICKING"
            title="选APP，记住这四件事"
            desc="面对五花八门的韩漫APP，抓住下面几点，就能挑到真正顺手的追更工具。"
            align="center"
          />
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {[
              { icon: "ri-image-2-fill", t: "画质与无遮拦", d: "是否支持高清原版与无遮拦内容，决定阅读观感。" },
              { icon: "ri-refresh-fill", t: "更新速度", d: "连载同步越快的APP，追更越不心累，体验越好。" },
              { icon: "ri-shield-star-line", t: "稳定与广告", d: "少闪退、少弹窗，才不会被频繁打断阅读节奏。" },
              { icon: "ri-download-2-fill", t: "缓存与多源", d: "支持离线缓存与多源切换，断更、无网都不怕。" },
            ].map((item) => (
              <div key={item.t} className="rounded-xl bg-background-200/60 border border-background-300/50 p-5 text-center">
                <span className="w-12 h-12 mx-auto rounded-full bg-primary-100/60 text-primary-500 flex items-center justify-center text-2xl">
                  <i className={item.icon}></i>
                </span>
                <h3 className="mt-3 font-heading text-sm text-foreground-950">{item.t}</h3>
                <p className="mt-2 text-xs text-foreground-600 leading-relaxed">{item.d}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-4 md:px-6 py-10 md:py-14 text-center">
        <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">还没想好用哪个？</h2>
        <p className="mt-3 text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
          如果你也是手机追更党，可以从支持缓存离线、更新快的韩漫APP入手，配合网页端备用，体验基本无忧。
        </p>
        <div className="mt-6 flex flex-col sm:flex-row justify-center gap-3">
          <Link to="/ziyuan" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md bg-primary-500 text-background-50 font-bold text-sm whitespace-nowrap hover:bg-primary-600 transition-colors">
            <i className="ri-compass-3-line"></i> 看看网页资源站
          </Link>
          <Link to="/faq" className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-md border border-background-300/70 text-foreground-950 font-bold text-sm whitespace-nowrap hover:border-accent-500 hover:text-accent-500 transition-colors">
            <i className="ri-question-line"></i> 遇到问题看FAQ
          </Link>
        </div>
      </section>
    </>
  );
}